<template>
    <AppPage :title="t('mine.backpackTitle')" :show-back="true">
        <AppHeader :show-back="true" :title="t('mine.backpackTitle')" v-if="!showImagePreview" />
        <SkeletonPresets preset="card" :loading="true" :animated="true" v-if="backpackList.length > 0 && isSwitching" />
        <div v-else>
            <div class="flex flex-wrap gap-15px mt-30px max-h-90vh overflow-y-auto" v-if="backpackList.length > 0">
                <div v-for="item in backpackList" :key="item.id" @click="handlePreviewImages(item)">
                    <div class="w-160px h-245px rounded-10px overflow-hidden">
                        <img :src="item?.thumb" alt="" class="w-100% h-100%">
                    </div>
                </div>
            </div>
            <div v-else class="flex items-center justify-center h-100vh">
                <AppEmpty :imgSrc="likeEmpty" :show-btn="false" />
            </div>
        </div>
        <!-- 全屏图片预览 -->
        <FullscreenImagePreview v-model:show="showImagePreview" :isShowbackDrop="false" :images="previewImages"
            :infoItem="infoItem" :start-position="previewStartPosition" @close="handleCloseImagePreview"
            :isShowSetAsBackdrop="isShowSetAsBackdrop" :isShowGotoChat="true" @goToChat="goToChat" />
    </AppPage>
</template>

<script setup lang="ts">
import { FullscreenImagePreview } from '@/components/feedback'
import { AppEmpty } from '@/components/display'
import { AppPage, AppHeader } from '@/components/layout'
import { onMounted } from 'vue'
import { ref } from 'vue'
import likeEmpty from '@/assets/images/message/like_empy.webp'
import { BackpackAPI } from '@/services/backpack'
import { userStorage } from '@/utils/storage';
import { MessageAPI } from '@/services/message'
import { useRouter } from "vue-router";
import { showLoadingToast,closeToast } from '@/utils/toast'
import { useI18n } from 'vue-i18n'

const backpackList = ref<any[]>([])
const showImagePreview = ref(false)
const previewImages = ref<string[]>([])
const previewStartPosition = ref(0)
const infoItem = ref()
const itemData = ref()
const isShowSetAsBackdrop = ref()
const isSwitching = ref(true)
const router = useRouter();
const { t } = useI18n()

const getBackpackListFun = async () => {
    const res = await BackpackAPI.getBackpackList({
        page: 1,
        pageSize: 100
    })
    backpackList.value = res?.data || []
    isSwitching.value = false
}

/**
 * 关闭图片预览
 */
const handleCloseImagePreview = () => {
    showImagePreview.value = false
    previewImages.value = []
    previewStartPosition.value = 0
}

/**
 * 预览图片
 */
const handlePreviewImages = (item: any) => {
    previewImages.value = [item.original]
    showImagePreview.value = true
    itemData.value = item
}

const goToChat = async () => {
    try {

        itemData.value.id = itemData.value.roleId

        showLoadingToast('loading')
        const res = await MessageAPI.getRoleDetail({
            id: itemData.value?.id,
        })

        // 1. 先存储数据 (避免跳转后数据丢失)
        userStorage.setDetailInfo(JSON.stringify(res.data))
        
        closeToast()
        // 2. 立即跳转，不等待 Promise 以获得更快的响应
        router.push({ path: '/chat' }).catch(() => { })

    } catch (error) {
        console.error('跳转失败:', error)
        // 即使出错也要跳转
        router.push({ path: '/chat' })
    }
}

onMounted(async () => {
    await getBackpackListFun()
})
</script>

<style scoped lang="scss">
.cards-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    width: 100%;
}

.card-item {
    width: 100%;
}

.btn {
    width: 210px;
    height: 36px;
    background: linear-gradient(180deg, #5A68FF 0%, #95A5FF 100%);
    border-radius: 20px;
}

.like-container {
    height: calc(100vh - 50px);
}
</style>
